import { useEffect, useMemo } from 'react';
import { useTenantStore } from '@/stores/prioritization/tenantStore';
import { useExecutionRecipeStore } from '@/stores/prioritization/executionRecipeStore';
import { recipesToWorkTypeOptions, type WorkTypeOption } from '@/types/work-type-recipes';

/** Load workspace work type catalog (built-ins + custom) for pickers and labels. */
export function useWorkTypeCatalog(workspaceId?: string | null) {
  const currentWorkspaceId = useTenantStore((s) => s.currentWorkspaceId);
  const wsId = workspaceId ?? currentWorkspaceId ?? null;

  const recipes = useExecutionRecipeStore((s) => s.recipes);
  const loading = useExecutionRecipeStore((s) => s.loading);
  const fetchRecipes = useExecutionRecipeStore((s) => s.fetchRecipes);

  useEffect(() => {
    void fetchRecipes(wsId);
  }, [fetchRecipes, wsId]);

  const options: WorkTypeOption[] = useMemo(
    () => recipesToWorkTypeOptions(recipes, wsId),
    [recipes, wsId],
  );

  const getLabel = (workType: string | null | undefined) => {
    if (!workType) return '';
    const opt = options.find((o) => o.value === workType);
    return opt?.label ?? workType;
  };

  return { options, recipes, loading, workspaceId: wsId, getLabel };
}
